import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

gsap.registerPlugin(ScrollToPlugin);
const body = document.querySelector("body");

const pagetop_btn = document.querySelector(".pagetop");

// pagetop_btnをクリックしたら
pagetop_btn.addEventListener('click', (e) => {
  e.preventDefault(); // デフォルトのリンク動作（ジャンプ）をキャンセル

  // href属性からターゲットIDを取得（例: #top）
  const targetId = e.target.getAttribute('href');

  // ターゲットとなる要素を取得（例: document.querySelector('#top')）
  const targetElement = document.querySelector(targetId);

  // ターゲット要素が存在すればスクロール
  if (targetElement) {
    // 少し遅延を加えてスクロール処理を確実に開始
    setTimeout(() => {
      gsap.to(window, {
        duration: 1, // アニメーションの持続時間（秒）
        ease: 'power4.out', // イージング（アニメーションの加速・減速）
        scrollTo: {
          y: targetElement.offsetTop, // スクロール先の位置を直接指定
          autokill: true // 競合するスクロールアクションをキャンセル
        }
      });
    }, 50); // 少し遅延を加える（必要に応じて調整）
  }
});


// スクロールされたら表示
window.addEventListener("scroll", scroll_event);


function scroll_event() {
  if (window.pageYOffset > 100) {
    pagetop_btn.style.opacity = "1";
  } else {
    pagetop_btn.style.opacity = "0";
  }
}

//ハンバーガーメニュー
let button = document.querySelector('.hd-menu_btn');  // 三本線ボタン
let nav_box = document.querySelector('.hd_nav_box');  //  三本線の中身メニュー
  button.addEventListener('click', function() {   // クリックしたとき

    if(nav_box.classList.contains('is_open') == true){  // .hd_nav_box　に　is_openクラスがついてたら

      nav_box.classList.remove("is_open");  //　メニュー表示　のクラスを削除　中身が見えない
      button.classList.remove("is_close");  //　閉じるボタン　のクラスを削除　元の三本線

    }else{

      nav_box.classList.add("is_open"); //　メニュー表示　のクラスをつける　中身が見える
      button.classList.add("is_close"); //　閉じる表示ボタン　のクラスをつける　×表示
    }
  });

let links = document.querySelectorAll('.hd_nav_link');

links.forEach((link) => {

  link.addEventListener('click', function() {

    setTimeout(() => {
      nav_box.classList.remove("is_open");
      button.classList.remove("is_close");
    }, 500);
});
})


//pc ヘッダースクロール
let windowWidth = document.documentElement.clientWidth;     // 画面幅を取得
if (windowWidth >= 1024) {    // 画面幅が1024px以上の場合とき
  let header = document.querySelector('.header'); // class[header]を取得
  if(document.body.classList.contains("index")){
  window.addEventListener('scroll', function(){     // スクロールしたとき
    let scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    // スクロールした距離を、関数[scroll]に代入

    if (scroll > 600){   //  200px以上スクロールしたら　= 別のヘッダー固定
      header.classList.add('is_fixed');   //.headerに追加
      header.classList.remove('is_hidden');   // 削除

    }else if (scroll > 100) {     // 100px以上スクロールしたら = ヘッダー隠れる
      header.classList.add('is_hidden');    //追加
      header.classList.remove('is_fixed');    // 削除

    }else{   // 100px未満スクロールしたら
      header.classList.remove('is_hidden'); // 削除
      header.classList.remove('is_fixed');  // 削除
    }
  });
  }else{
    header.classList.add('is_fixed');
  }
}


//ページ内リンク

gsap.registerPlugin(ScrollToPlugin);// ScrollToPluginを使うときに必要

window.addEventListener("load", ()=>{
  const navLinks = document.querySelectorAll('a[href^="#"]'); // #から始まるリンクを取得
  const headerHeight = document.querySelector('.header').offsetHeight; //　ヘッダーの高さを取得

  navLinks.forEach((navLink) => { // #から始まる全てのリンクを１つ１つnavLinkに入れる

    if(navLink){
      navLink.addEventListener("click" , (e) => {  //　navLinkをクリックしたら (e)=後で使うための宣言
        e.preventDefault(); //　イベント動作をキャンセル（リンクで飛ばすのをキャンセル）
        let id = navLink.getAttribute("href"); //　navLinkに入っているリンクをidに代入
        gsap.to(window, { //　gsap(jsのライブラリ)の呼び出し、最終どうしたいか(スクロールを調整=winodw)
          duration : 0.5, // アニメーションの設定(秒数)
          scrollTo:{ //　97行目でクリックしたときの行き先設定
            y: id, // y軸　99行目idの先
            offsetY: headerHeight + 0 //　ヘッダー分ずらす
          }
        });
      });
    }
  });
});

//モーダル
let modals = document.querySelectorAll('.service-introduction_kinds_item');
//document=htmlの中からを('.●●●')を取得
let modal_wrap = document.querySelector('.modal_wrap');
let modal_title = document.querySelector('.modal_title');
let modal_text = document.querySelector('.modal_text');
let modal_image = document.querySelector('.modal_img img');

modals.forEach(modal => {
  modal.addEventListener('click', function(){

    let title = modal.querySelector('.service-introduction_kinds_image_text').textContent;
    //modalの中の.service-introduction_kinds_image_textを取得、.textContentで文字列だけを取得 （例：アクセントクロス）
    modal_title.innerText = title;
    //上で取得したタイトル（例：アクセントクロス）をモーダル表示のタイトルに反映・書き換え

    let image= modal.querySelector('.service-introduction_kinds_image img');
    //.service-introduction_kinds_image の img を取得
    let image_src = image.getAttribute('src');
    //image のsrcを取得、image_srcに格納

    modal_image.setAttribute('src',image_src);
    //modal_imageのsrcに、image_srcのsrcを入れる（新しいURLに変更）


    let detail_text = modal.querySelector('.service-introduction_kinds_image_detail_text').textContent;
    modal_text.innerText = detail_text;

    if(modal.classList.contains('is_open') == true){
      // .service-introduction_kinds_image　に　is_openクラスがついてたら

      modal.classList.remove('is_open');
      modal_wrap.classList.remove('is_open');

    }else{
      modal.classList.add('is_open');
      modal_wrap.classList.add('is_open');
    }
  });
});

modals.forEach(modal => {
  modal.addEventListener('click', function(){
    let close_btn = document.querySelector('.modal_close_btn');
    close_btn.addEventListener('click', function() {
      if(modal_wrap.classList.contains('is_open') == true){
        // modal_wrap(.modal_wrap)　に　is_openクラスがついてたら

        modal_wrap.classList.remove('is_open');
        // modal_wrap(.modal_wrap)　の　is_openを外す（モーダルを閉じる）
        modal.classList.remove('is_open');
      }else{

      }
    });
  });
});

//スライダー
if(document.body.classList.contains("single")) {
  // サムネイル
    const sliderThumbnail = new Swiper(".slider-thumbnail", {
      slidesPerView: "auto", // サムネイルの枚数
    });
    // スライダー
    const slider = new Swiper(".slider", {
      loop: true,
      effect: "fade", // フェード
      // 前後の矢印
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: sliderThumbnail,
      },
  });}
  if(document.body.classList.contains("contact")){
      topValidation('zip', 'address01', 'address02');
    }

    /*----------------------------------------
contact MWWP Form
------------------------------------------*/

window.addEventListener('load', () => {
  let headerHeight = document.querySelector(".header").offsetHeight;
    if (body.classList.contains("contact")) {
      let selectEle = document.querySelector("select")
    }
  let formElement = document.querySelector('.contact-form_sec');
  let confirmEle = document.querySelector('.mw_wp_form_confirm');
    if(confirmEle) {
      location.hash = '#scroll';
    }
    if (formElement && location.hash == '#scroll') {
      var posy = formElement.offsetTop - headerHeight;
      window.scrollTo({
        top: posy,
        behavior: 'smooth'
      });
    }
});

document.addEventListener("DOMContentLoaded", function () {
  if (body.classList.contains("contact")) {
    var errorElement = document.querySelector('.error');
    if (errorElement) {
      document.querySelector('.mw_wp_form').classList.add('mw_wp_form_error');
      var position = errorElement.parentElement.offsetTop - headerHeight;
      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    }
  }
});

